import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import AdminDashboard from '../pages/admin/Dashboard';
import PropertyList from '../pages/admin/PropertyList';
import PropertyFormPage from '../pages/admin/PropertyForm';
import InquiriesList from '../pages/admin/InquiriesList';
import ContentManager from '../pages/admin/ContentManager';
import ErrorBoundary from '../components/common/ErrorBoundary';
import { useError } from '../context/ErrorContext';
import Settings from '../pages/admin/Settings';

/**
 * @typedef {Object} RouteConfig
 * @property {string} path - Route path
 * @property {React.ComponentType} Component - Component to render
 * @property {string} title - Page title
 */

/** @type {RouteConfig[]} */
const adminRoutes = [
  { path: 'dashboard', Component: AdminDashboard, title: 'Dashboard' },
  { path: 'properties', Component: PropertyList, title: 'Properties' },
  { path: 'properties/new', Component: PropertyFormPage, title: 'New Property' },
  { path: 'properties/:id/edit', Component: PropertyFormPage, title: 'Edit Property' },
  { path: 'inquiries', Component: InquiriesList, title: 'Inquiries' },
  { path: 'content', Component: ContentManager, title: 'Content Management' },
  { path:'settings' , Component: Settings, title:"Settings" }
];

const RouteErrorBoundary = ({ children }) => {
  const { showError } = useError();

  const handleError = (error) => {
    showError(
      'An error occurred while rendering this page',
      'error',
      'ROUTE001',
      { error: error.message }
    );
  };

  return (
    <ErrorBoundary onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={
          <RouteErrorBoundary>
            <AdminDashboard />
          </RouteErrorBoundary>
        } />
        
        {adminRoutes.map(({ path, Component, title }) => (
          <Route
            key={path}
            path={path}
            element={
              <RouteErrorBoundary>
                <Component />
              </RouteErrorBoundary>
            }
          />
        ))}
      </Route>
    </Routes>
  );
};

export default AdminRoutes; 